module.exports = __webpack_public_path__ + "img/HeroTypesQuiz-Q7.19cfc2a1.png";